import TabLabel from "./tab-label/TabLabel";
import {useTheme} from "@mui/material/styles";
import Tab from "@mui/material/Tab";
import TabPanel from "./tab-panel/TabPanel";
import Tabs from "@mui/material/Tabs";
import {FC, SyntheticEvent} from "react";
import {alpha, Theme} from "@mui/material";
import {SxProps} from "@mui/system";

interface ITabs {
    title: string
    subtitle?: string | number
    component: React.ReactNode
}

interface Props {
    tabs: ITabs[]
    color?: "primary" | "secondary"
    handleTabChange: (e: SyntheticEvent, value: number) => void
    selectedTab: number
    noPanels?: boolean
    noTabLabel?: boolean
    spacing?: number
    variant?: 'standard' | 'scrollable' | 'fullWidth';
    sx?: SxProps<Theme>
}

const CustomTabs: FC<Props> = ({color = "primary", variant = "scrollable", spacing = 2, ...props}) => {
    const theme = useTheme()

    const renderTabs = props.tabs.map((t, idx) => {
        return (
            <Tab key={`tab-${idx}`}
                 label={!props.noTabLabel ? <TabLabel title={t.title} subtitle={t.subtitle}/> : t.title}/>
        )
    });

    const renderTabPanels = props.tabs.map((t, idx) => {
        return (<TabPanel value={props.selectedTab} key={`tab-panel-${idx}`} index={idx}>
            {t.component}
        </TabPanel>)
    });

    return (
        <>
            <Tabs variant={variant}
                  allowScrollButtonsMobile
                  textColor={color}
                  indicatorColor={color}
                  sx={{
                      mt: theme.spacing(spacing),
                      "& .MuiTabs-scrollButtons": {
                          color: theme.palette[color].main,
                      },
                      "& .MuiTabs-scrollButtons.Mui-disabled": {
                          display: "none", // Completely hide disabled buttons
                      },
                      borderBottom: `1px solid ${alpha(theme.palette[color].main, 0.3)}`,
                      ...props.sx,
                  }}
                  value={props.selectedTab}
                  onChange={props.handleTabChange}
                  aria-label="Custom tabs">
                {renderTabs}
            </Tabs>
            {!props.noPanels ? renderTabPanels : null}
        </>
    )
};

export default CustomTabs;
